import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import logo from '../../assests/images/calendarBannerHomepage.svg'; // Make sure the path is correct
import { useNavigate, useLocation } from 'react-router-dom';
import { CORE_USER, GENERAL_USER, TPO_ADMIN } from '../../utils/Constants';
import { getUrlWithParams, hasCommonElement } from '../../utils/Utils';
import { useSelector } from 'react-redux';
import { useOkta } from '../../hooks/oktaHook';
import { fetchUserDetail } from '../HomePage/service';

const BannerComponent = ({ isCalendarCreated, tasks, isLoading }) => {
  const navigate = useNavigate();
  const { userDetails } = useOkta();
  const userRole = userDetails?.roles;
  const selectedCycleObj = useSelector((state) => state.cycle.selectedCycleObj);
  const { search } = useLocation();

  const newParams = new URLSearchParams(search);
  const selectedCycleId = Number(newParams.get('cycleId'));
  const selectedCycle = newParams.get('cycleName');
  const selectedBu = newParams.get('bu');

  const [typoText1, setTypoText1] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [navigateLink, setNavigateLink] = useState('');
  const [userType, setUserType] = useState('');
  useEffect(() => {
    if (userDetails?.email && selectedBu) {
      getLoginData(userDetails?.email, selectedBu);
    }
  }, [selectedBu, userDetails]);

  const getLoginData = async (email, selectedBu) => {
    try {
      const data = await fetchUserDetail(userDetails?.email, selectedBu);
      if (data) {
        setUserType(data?.functionName);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const checkTaskStatus = () => {
    const setTaskDetails = (typoText, buttonText, navigateLink) => {
      setTypoText1(typoText);
      setButtonText(buttonText);
      setNavigateLink(navigateLink);
    };

    const roleBasedText = (isAdmin, adminText, userText) => (isAdmin ? adminText : userText);

    return tasks?.some((task, index) => {
      const { taskName, status } = task;
      const isAdmin = userRole.some((role) => [CORE_USER, TPO_ADMIN].includes(role));
      const isUser = userRole.includes(GENERAL_USER);
      const nextTask = tasks[index + 1];

      switch (taskName) {
        case 'Setup Team':
          if (status === 'Not Started') {
            setTaskDetails(
              roleBasedText(isAdmin, 'Setup your team', 'Hi! Check your team details'),
              'View Team',
              '/setup-team'
            );
            return true;
          }
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(isAdmin, 'Your Team is set Up', 'Hi! Check your team details'),
              'View Team',
              '/setup-team'
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Prep Master File' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              'Nice Job so far! Up Next: Prep Master File',
              'Prep Master File',
              '/portfolio/master-data'
            );
            return true;
          }
          break;

        case 'Prep Master File':
          if (status === 'In Progress') {
            setTaskDetails(
              'Nice Job so far! Up Next: Prep Master File',
              'Prep Master File',
              '/portfolio/master-data'
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Trigger Cycle' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Good Start! Up Next: Trigger your Cycle',
                'Hi! Your PO Lead will trigger the cycle soon'
              ),
              roleBasedText(isAdmin, 'Cycle Trigger', 'HomePage'),
              roleBasedText(isAdmin, '/portfolio/cycle-trigger', '/home')
            );
            return true;
          }
          break;

        case 'Trigger Cycle':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Hi! Check your Cycle Run Status',
                'Hi! The PO Lead has initiated the cycle, and it is currently in progress'
              ),
              roleBasedText(isAdmin, 'Cycle Trigger', 'HomePage'),
              roleBasedText(isAdmin, '/portfolio/cycle-trigger', '/home')
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Steering Reco' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              'Analyze your cycle results: Portfolio Summary',
              'Portfolio Summary',
              '/cycle-analytics/portfolio-details'
            );
            return true;
          }
          break;

        case 'Steering Reco':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                "It's time to validate the Portfolio Optimization Results!",
                'Portfolio Recommendations are in progress. Meanwhile, you can analyze your portfolio'
              ),
              'Voting and Alignment',
              '/alignment-action/feedback-collation'
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Functional Feedback' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                "Well Done, you have submitted your Recommendation for all SKUs. It's time to vote for functional users",
                isUser && (userType !== 'Region' || userType !== 'Channel')
                  ? 'Hi! PO Lead has completed voting. Please initiate Voting'
                  : "Well Done, you have submitted your Recommendation for all SKUs. It's time to vote for functional users"
              ),
              roleBasedText(isAdmin, 'Calendar Cadence', 'Voting and Alignment'),
              roleBasedText(isAdmin, '/readiness/calendar', '/alignment-action/feedback-collation')
            );
            return true;
          }
          break;

        case 'Functional Feedback':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Hi! The Functional Team has started the voting process',
                isUser && (userType !== 'Region' || userType !== 'Channel')
                  ? 'Hi! Please complete your voting'
                  : 'Hi! The Functional Team has started the voting process'
              ),
              roleBasedText(
                isAdmin,
                'Calendar Cadence',
                isUser && (userType !== 'Region' || userType !== 'Channel')
                  ? 'Voting and Alignment'
                  : 'Calendar Cadence'
              ),
              roleBasedText(
                isAdmin,
                '/readiness/calendar',
                isUser && (userType !== 'Region' || userType !== 'Channel')
                  ? '/alignment-action/feedback-collation'
                  : '/readiness/calendar'
              )
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Regional Decisions' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                "Hi! The Functional team has completed the voting process. It's now time for the Regional team to initiate their voting",
                isUser && (userType === 'Region' || userType === 'Channel')
                  ? 'You know your Region best, time to take a decision for your region'
                  : "Well done! You have submitted recommendations for all SKUs. It's time to vote for Regional Users"
              ),
              roleBasedText(
                isAdmin,
                'Voting and Alignment',
                isUser && (userType === 'Region' || userType === 'Channel')
                  ? 'Voting and Alignment'
                  : 'Decision Making Central'
              ),
              roleBasedText(
                isAdmin,
                '/alignment-action/feedback-collation',
                isUser && (userType === 'Region' || userType === 'Channel')
                  ? '/alignment-action/feedback-collation'
                  : '/alignment-action/decision-making-central'
              )
            );
            return true;
          }
          break;

        case 'Regional Decisions':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Hi! The Regional Team has started the voting process',
                isUser && (userType === 'Region' || userType === 'Channel')
                  ? 'You know your Region best, time to take a decision for your region'
                  : 'Hi! The Regional Team has initiated Voting'
              ),
              roleBasedText(isAdmin, 'Calendar Cadence', 'Voting and Alignment'),
              roleBasedText(isAdmin, '/readiness/calendar', '/alignment-action/feedback-collation')
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Final Decisions' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'HI! Regional decisions are submitted, your turn to lock in the final decisions',
                isUser && (userType === 'Region' || userType === 'Channel')
                  ? 'Well done! You have completed the voting. PO Lead will initiate the final decision'
                  : 'Regional Team completed Voting. PO lead will initiate the final decision'
              ),
              'Decision Making Central',
              '/alignment-action/decision-making-central'
            );
            return true;
          }
          break;

        case 'Final Decisions':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Hi! Please submit your final decisions',
                'Regional Team completed Voting. PO lead will initiate the final decision'
              ),
              roleBasedText(isAdmin, 'Decision Making Central', 'Calendar Cadence'),
              roleBasedText(
                isAdmin,
                '/alignment-action/decision-making-central',
                '/readiness/calendar'
              )
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Communication Plan' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Thank you for submitting your decisions. Actions have been communicated to the respective teams. Please track progress',
                'Final Decisions for this cycle are now locked! Check your outlook/Notification for assigned actions to you!'
              ),
              roleBasedText(isAdmin, 'Decision Making Central', 'Calendar Cadence'),
              roleBasedText(
                isAdmin,
                '/alignment-action/decision-making-central',
                '/readiness/calendar'
              )
            );
            return true;
          }
          break;

        case 'Communication Plan':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Thank you for submitting your decisions. Actions have been communicated to the respective teams. Please track progress',
                'Final Decisions for this cycle are now locked! Check your outlook/Notification for assigned actions to you!'
              ),
              'Calendar Cadence',
              '/readiness/calendar'
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Execute Actions' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Congratulation you have submitted decisions',
                'Pick up where you left.. Head to Decision making Central for updating the completion status of Actions assigned to you'
              ),
              roleBasedText(isAdmin, 'Decision Making Central', 'Calendar Cadence'),
              roleBasedText(
                isAdmin,
                '/alignment-action/decision-making-central',
                '/readiness/calendar'
              )
            );
            return true;
          }
          break;

        case 'Execute Actions':
          if (status === 'In Progress') {
            setTaskDetails(
              roleBasedText(
                isAdmin,
                'Things are in progress—please check the completion status of actions assigned to your team',
                'Pick up where you left.. Head to Decision making Central for updating the completion status of Actions assigned to you'
              ),
              roleBasedText(isAdmin, 'Decision Making Central', 'Calendar Cadence'),
              roleBasedText(
                isAdmin,
                '/alignment-action/decision-making-central',
                '/readiness/calendar'
              )
            );
            return true;
          }
          if (
            status === 'Completed' &&
            nextTask?.taskName === 'Track Performance' &&
            nextTask?.status === 'Not Started'
          ) {
            setTaskDetails(
              'The hard work is done! See the results, track performance on Portfolio Health!',
              'Portfolio Health',
              '/portfolio/master-data'
            );
            return true;
          }
          break;

        case 'Track Performance':
          if (status === 'In Progress' || status === 'Completed') {
            setTaskDetails(
              '	The hard work is done! See the results, track performance on Portfolio Health!',
              'Portfolio Health',
              '/portfolio/master-data'
            );
            return true;
          }
          break;

        default:
          return false;
      }
    });
  };

  useEffect(() => {
    checkTaskStatus();
  }, [tasks]);

  const handleButtonClick = () => {
    if (navigateLink) {
      navigate(getUrlWithParams(navigateLink, selectedBu, selectedCycle, selectedCycleId));
    } else {
      navigate(getUrlWithParams('/readiness/calendar', selectedBu, selectedCycle, selectedCycleId));
    }
  };

  if (!isCalendarCreated) {
    return (
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '150px',
          left: 0,
          top: 0,
          background: 'linear-gradient(135.6deg, #004A96 24.74%, #337DC9 62.9%)',
          boxShadow: '4px 0px 24px -2px rgba(0, 92, 188, 0.08)',
          borderRadius: '9px',
          padding: '20px',
          display: 'flex',
          alignItems: 'center', // Center vertically
          justifyContent: 'space-between' // Push elements to the sides
        }}>
        {/* Logo */}
        <img
          style={{
            width: '70px',
            height: '70px',
            marginLeft: '20px'
          }}
          src={logo}
        />

        {/* Text Section */}
        <Stack
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center', // Center text vertically
            marginLeft: '20px'
          }}>
          <Typography
            variant="h5"
            sx={{ color: 'rgba(239, 239, 239, 1)', fontSize: '24px', width: '80%' }}>
            Next step setup your calendar.Your calendar must be set up before you can initiate
            voting.
          </Typography>
        </Stack>

        {/* Button */}
        <Button
          variant="contained"
          sx={{
            width: '200px',
            height: '40px',
            backgroundColor: '#FFFFFF',
            borderRadius: '24px',
            color: 'rgba(48, 72, 228, 1)',
            '&:hover': {
              backgroundColor: '#FFFFFF',
              boxShadow: 'none'
            },
            marginRight: '20px' // Ensure some space from the right
          }}
          disabled={
            (!isCalendarCreated && hasCommonElement(userRole, [GENERAL_USER])) ||
            selectedCycleObj['testCycle']
          }
          onClick={handleButtonClick}>
          Go To Calendar
        </Button>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '150px',
          left: 0,
          top: 0,
          background: 'linear-gradient(135.6deg, #004A96 24.74%, #337DC9 62.9%)',
          boxShadow: '4px 0px 24px -2px rgba(0, 92, 188, 0.08)',
          borderRadius: '9px',
          padding: '20px',
          display: 'flex',
          alignItems: 'center', // Center vertically
          justifyContent: 'space-between' // Push elements to the sides
        }}>
        {/* Logo */}
        <img
          style={{
            width: '70px',
            height: '70px',
            marginLeft: '20px'
          }}
          src={logo}
        />

        {/* Text Section */}
        <Stack
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center', // Center text vertically
            marginLeft: '20px'
          }}>
          <Typography
            variant="h5"
            sx={{ color: 'rgba(239, 239, 239, 1)', fontSize: '24px', width: '80%' }}>
            {typoText1}
          </Typography>
        </Stack>

        {/* Button */}
        <Button
          variant="contained"
          sx={{
            width: '200px',
            height: '40px',
            backgroundColor: '#FFFFFF',
            borderRadius: '24px',
            color: 'rgba(48, 72, 228, 1)',
            '&:hover': {
              backgroundColor: '#FFFFFF',
              boxShadow: 'none'
            },
            marginRight: '20px' // Ensure some space from the right
          }}
          disabled={!isCalendarCreated && hasCommonElement(userRole, [GENERAL_USER])}
          onClick={handleButtonClick}>
          {buttonText}
        </Button>
      </Box>
    );
  }
};

export default BannerComponent;
